export const DASHBOARD_RT = 'dashboard';
export const REBANHO_RT = 'rebanho';
export const DISPOSITIVOS_RT = 'dispositivos';
export const USUARIOS_RT = 'usuarios';
export const GRUPOS_RT = 'grupos';
export const GRUPOSID_RT = 'grupos/:id';
export const ESTACAO_RT = 'estacoes';
